import { FC, Ref } from "react";
import { Card, CardBody, Col, Container, Label, Row, Table } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { Total } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { getCartTotal, getallCardTotal } from "../../../Service/Ecommerce.service";
import { CartType } from "../../../Type/EcommerceType";
import InvoiceDescription from "./InvoiceDescription";
import InvoiceHeader from "./InvoiceHeader";
import PrintInvoice from "./PrintInvoice";
import TableHeadings from "./TableHeadings";

const ItemDescription: FC<{ ref: Ref<HTMLDivElement | null> | undefined }> = ({ ref }) => {
  const { cart } = useAppSelector((state) => state.cartData);
  const { symbol } = useAppSelector((state) => state.product);

  return (
    <div ref={ref}>
      <Container className="invoice">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div>
                  <InvoiceHeader />
                  <InvoiceDescription />
                  <div className="table-responsive theme-scrollbar invoice-table mt-3" id="table">
                    <Table bordered striped>
                      <tbody>
                        <TableHeadings />
                        {cart?.map((item: CartType) => (
                          <tr key={item.id}>
                            <td>
                              <Label>{item.name}</Label>
                              <P className="m-0">{item.note}</P>
                            </td>
                            <td>
                              <P className="itemtext">{item.total}</P>
                            </td>
                            <td>
                              <P className="itemtext">
                                {symbol}
                                {item.discountPrice}
                              </P>
                            </td>
                            <td className="payment">
                              <P className="itemtext digits">
                                {symbol}
                                {getCartTotal(item)}
                              </P>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td></td>
                          <td></td>
                          <td className="Rate">
                            <H4 className="f-w-700 mb-0 p-2">{Total}</H4>
                          </td>
                          <td className="payment degits">
                            <H4 className="f-w-700 mb-0 p-2">
                              {symbol}
                              {getallCardTotal(cart)}
                            </H4>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <PrintInvoice />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ItemDescription;
